import {string} from "@src/libs/yup";

export default string().required("Please enter a value");